// removed by extract-text-webpack-plugin
module.exports = {"s":"(min-width: 34em)","m":"(min-width: 48em)","l":"(min-width: 64em)","xl":"(min-width: 75em)","spacesize-s":"24px","spacesize-m":"48px","ixt-blue":"#003B5C","ixt-blue-50":"#e3f1fc","ixt-blue-600":"#205779","ixt-blue-800":"#00304d","ixt-green-300":"#5ece84","ixt-yellow-300":"#ffe055"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home.css
// module id = 588
// module chunks = 2